import { RootState } from '../store';

// Pure selector functions
export const selectMilestoneMap = (state: RootState, mapUuid: string) =>
  state.map3Data.milestoneMaps.find((map) => map.uuid === mapUuid);

export const selectObjective = (state: RootState, objectiveUuid: string) =>
  state.map3Data.objectives.find((obj) => obj.uuid === objectiveUuid);

// calculateIntervalRange now lives in @mm-shared/intervals; re-exported for existing consumers.
export { calculateIntervalRange } from '@mm-shared/intervals';
